const items = document.querySelectorAll('[data-accordion-item]')

const TRANSITION_DURATION = 700

/** @param {HTMLDetailsElement} details */
function closeAccordionItem (details) {
  const content = details.querySelector('[data-js="collapsible-content"]')

  content.style.transition = 'none'
  content.style.maxHeight = `${content.getBoundingClientRect().height}px`

  window.requestAnimationFrame(() => {
    plausible('close_accordion_item')

    window.requestAnimationFrame(() => {
      content.style.transition = `max-height ${TRANSITION_DURATION}ms ease-in-out`
      content.style.maxHeight = 0
      // details.scrollIntoView({ behavior: 'smooth' })
      setTimeout(() => {
        details.removeAttribute('open')
      }, TRANSITION_DURATION)
    })
  })
}

/**
 * @param {MouseEvent} event
 */
function handleCloseButtonClick (event) {
  if ('accordionItemClose' in event.target.dataset) {
    const details = event.currentTarget
    closeAccordionItem(details)
  }
}

/**
 * @param {Event} event
 */
function toggleAccordionItem (event) {
  // prevent default toggle behavior so we can animate it
  event.preventDefault()

  /** @type {HTMLElement} */
  const summary = event.currentTarget
  /** @type {HTMLDetailsElement} */
  const details = summary.parentElement

  if (!details.open) {
    const summaryTitle = summary.textContent.trim()
    plausible('open_accordion_item')

    const content = details.querySelector('[data-js="collapsible-content"]')
    const innerContent = details.querySelector('[data-js="inner-content"]')

    details.setAttribute('open', true)
    content.style.transition = 'none'
    content.style.maxHeight = 0

    window.history.replaceState(null, '', details.dataset.url)
    document.title = window.__SITE_SETTINGS__.titleTemplate.replace(
      '%{title}',
      summaryTitle
    )

    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        content.style.transition = `max-height ${TRANSITION_DURATION}ms ease-in-out`
        content.style.maxHeight = `${
          innerContent.getBoundingClientRect().height
        }px`
      })
    })
  } else {
    if (!document.querySelectorAll('details[open]').length) {
      window.history.replaceState(
        null,
        '',
        details.dataset.url.split('/').slice(0, -1).join('/')
      )
    }

    closeAccordionItem(details)
  }
}

items.forEach((details) => {
  details.addEventListener('click', handleCloseButtonClick)
  details
    .querySelector('summary')
    .addEventListener('click', toggleAccordionItem)
})

const activeItem = document.querySelector('details[open]')

if (!('scrollBehavior' in document.documentElement.style)) {
  import('smoothscroll-polyfill').then((module) => {
    module.polyfill()

    if (activeItem) {
      activeItem.scrollIntoView({ behavior: 'smooth' })
    }
  })
} else {
  if (activeItem) {
    activeItem.scrollIntoView({ behavior: 'smooth' })
  }
}

// Share Buttons

/** @type {NodeListOf<HTMLButtonElement>} */
const shareButtons = document.querySelectorAll('[data-js-share-button]')

/**
 * @param {MouseEvent} event
 */
function handleShare (event) {
  plausible('share_offer')

  /** @type {HTMLButtonElement} */
  const button = event.target

  if (navigator.share) {
    navigator.share({
      text: window.__SITE_SETTINGS__.titleTemplate.replace(
        '%{title}',
        button.dataset.title
      ),
      url: button.dataset.url
    })
  } else {
    navigator.clipboard.writeText(button.dataset.url).then(() => {
      const text = button.textContent
      button.textContent = button.dataset.copied
      button.disabled = true

      setTimeout(() => {
        button.textContent = text
        button.disabled = false
      }, 5000)
    })
  }
}

shareButtons.forEach((button) => {
  button.addEventListener('click', handleShare)
})
